import React, { useEffect, useState } from "react";
import "../../style/css/about.css";
// import { useGetAllChaptersPaginationMutation } from "../../app/services/chapterServices";
// import { useGetAllMemberListMutation } from "../../app/services/memberListServices";
import { useHomePageTotalCountQuery } from '../../app/services/memberServices'
// import { useGetAllSIGPaginationMutation } from "../../app/services/SIGServices";
import { Button } from 'react-bootstrap';
import { selectCurrentScope } from "../../app/auth/authSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AnimatedNumber = ({ target }) => {
  const [count, setCount] = useState(0);


  useEffect(() => {
    if (count < target) {
      const interval = setInterval(() => {
        setCount((prev) => {
          const nextValue = prev + Math.ceil(target / 50);
          return nextValue >= target ? target : nextValue;
        });
      }, 30);

      return () => clearInterval(interval);
    }
  }, [count, target]);

  return <span>{count.toLocaleString()}</span>;
};


function AboutSection() {
  const currentScope = useSelector(selectCurrentScope);

  const {
    data: totalCountData,
  } = useHomePageTotalCountQuery();
  const navigate = useNavigate(); //route

  // const roundUpCount = (count) => {
  //   if (count < 100) {
  //     return Math.ceil(count / 10) * 10; // Round to nearest 10
  //   } else if (count < 1000) {
  //     return Math.ceil(count / 100) * 100; // Round to nearest 100
  //   } else {
  //     return Math.ceil(count / 1000) * 1000; // Round to nearest 1000
  //   }
  // };

  // const roundedData = totalCountData?.data
  //   ? {
  //       individualMemberTotalCount: roundUpCount(totalCountData?.data?.individualMemberTotalCount),
  //       institutionalMemberTotalCount: roundUpCount(totalCountData?.data?.institutionalMemberTotalCount),
  //       chapterTotalCount: roundUpCount(totalCountData?.data?.chapterTotalCount),
  //       partnerTotalCount: roundUpCount(totalCountData?.data?.partnerTotalCount),
  //       eventTotalCount: roundUpCount(totalCountData?.data?.eventTotalCount),
  //     }
  //   : {};
  const roundedData = totalCountData?.data
    ? {
      individualMemberTotalCount: totalCountData?.data?.individualMemberTotalCount,
      institutionalMemberTotalCount: totalCountData?.data?.institutionalMemberTotalCount,
      chapterTotalCount: totalCountData?.data?.chapterTotalCount,
      partnerTotalCount: totalCountData?.data?.partnerTotalCount,
      eventTotalCount: totalCountData?.data?.eventTotalCount,
    }
    : {};

  const stats = [
    { number: roundedData?.individualMemberTotalCount, label: "Individual Members" },
    { number: roundedData?.institutionalMemberTotalCount, label: "Institutional Members" },
    { number: roundedData?.chapterTotalCount, label: "Chapters Across India" },
    { number: roundedData?.partnerTotalCount, label: "Partners Across the Globe" },
    { number: roundedData?.eventTotalCount, label: "Events Organised So Far" },
  ];
  // useEffect(()=>{
  //   homeTotalcount.then((res)=>{
  //   })
  // },[homeTotalcount])



  // Decrease the interval for smoother transition


  //Router Portal
  const joinMember = () => {
    if (currentScope === "PORTAL_SUPER_ADMIN") {
      navigate("/admin/membershipPage");
    } else if (currentScope === "PORTAL_ADMIN") {
      navigate("/assistantAdmin/membershipPage");
    }
    else if (currentScope === "PORTAL_CHAPTER_ADMIN") {
      navigate("/chapterAdmin/membershipPage");
    } else if (currentScope === "PORTAL_SIG_ADMIN") {
      navigate("/sigAdmin/membershipPage");
    } else if (currentScope === "PORTAL_MEMBER") {
      navigate("/member/membershipPage");
    } else {
      navigate("/membershipPage");
    }
  };

  // Decrease the interval for smoother transition


  return (
    // <div  className="abt-bg" style={{ position: "relative", top: "53px" }}>
    //   <div className="row aboutsection-container">
    //     <div className="d-flex justify-content-center p-0">
    //       <div>
    //         <div className="d-flex ms-5">
    //           <h2 className="custom-header ms-0">About ELTAI</h2>
    //           <hr className="about-hr ms-4 me-4 d-none d-md-block" />
    //         </div>
    //         <div className="ms-auto align-items-center mt-2 mt-md-0">
    //           <p className="w-60 text-justify signika fw-bold abt-text">
    //             Founded on August 7, 1969, by the visionary Padmashri S. Natarajan and five pioneering educators, the English Language Teachers' Association of India (ELTAI) has flourished into the nation's largest network of English teachers. From an initial 250 members, it has grown to over 5,500 strong, spanning 60 chapters across India. ELTAI stands as a global force, collaborating with esteemed bodies like IATEFL (UK) and TESOL (USA), and offering journals, e-publications, and transformative events. Through our conferences, workshops, and consultancy services, we empower educators with cutting-edge insights, shaping the future of English teaching in India.
    //           </p>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div>
    //     <div className="row mb-5">
    //       <div className="event-counter-section section-padding">
    //         <>
    //           <Container maxWidth="xl" className="ms-md-3 ms-0">
    //             <div className="row align-items-center ">
    //               <div className="col-xl-3 col-md-12 col-sm-12 text-md-center">
    //                 <div className="section-title">
    //                   <h5 className="sub-title signika">Become a member</h5>
    //                   <h2 className="title signika">Grow with us.</h2>
    //                   <h2 className="title signika">
    //                   Lead the future.
    //                   </h2>
    //                 </div>
    //               </div>
    //               <div className="col-xl-9 col-md-12 col-sm-12">
    //                 <div className="row d-flex justify-content-center">
    //                   <div className="counter-item">
    //                     <div className="counter-item-inner">
    //                       <h1 className="counter-numb counter color1">5000+</h1>
    //                       <span className="signika member-config">
    //                         Individual Members
    //                       </span>
    //                     </div>
    //                   </div>
    //                   <div className="counter-item">
    //                     <div className="counter-item-inner">
    //                       <h1 className="counter-numb counter color2">200+</h1>
    //                       <span className="signika chapter-config">
    //                         Institutional Members
    //                       </span>
    //                     </div>
    //                   </div>
    //                   <div className="counter-item">
    //                     <div className="counter-item-inner">
    //                       <h1 className="counter-numb counter color3">70+</h1>
    //                       <span className="signika sig-config">
    //                       Chapters Across India
    //                       </span>
    //                     </div>
    //                   </div>
    //                   <div className="counter-item">
    //                     <div className="counter-item-inner">
    //                       <h1 className="counter-numb counter color2">100+</h1>
    //                       <span className="signika sig-config">
    //                       Partners Across the Globe
    //                       </span>
    //                     </div>
    //                   </div>
    //                   <div className="counter-item">
    //                     <div className="counter-item-inner">
    //                       <h1 className="counter-numb counter color1">900+</h1>
    //                       <span className="signika sig-config">Events </span>
    //                       <br />
    //                       <span className="signika sig-config">So Far</span>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </Container>
    //         </>
    //       </div>
    //     </div>
    //   </div>



    // </div>
    <>
      <section className="eltai-section p-md-5 p-3  overallPadding">
        <div className="stats-grid d-md-grid justify-content-evenly">
          {stats.map((stat, index) => (
            <div key={index} className="stat-box">
              <h2 className="title-font"><AnimatedNumber target={stat?.number} />{stat?.number !== 0 ? "" : ""}</h2>
              <p className="content-font">{stat?.label}</p>
            </div>
          ))}
        </div>
        <h1 className="about_heading alata-light title-font">ELTAI: Empowering Educators, Enriching Classrooms</h1>
        <div class="about_content content-font">
          <video class="about_video" controls>
            <source src={`${process.env.REACT_APP_PUBLIC_URL}/assets/videos/Eltai.mp4`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="about_txt">
            The English Language Teachers' Association of India (ELTAI) stands
            as the largest and oldest network of English language and literature
            educators in the country. Established on 5<sup>th</sup> June 1974 by the
            visionary Padmashree S. Natarajan, ELTAI has grown into a thriving
            community that continues to inspire and support teachers on their
            journey of professional growth.
          </p>
          <p className="about_txt">
            Like the resilient Indian banyan tree, our organisation has spread
            its roots far and wide, evolving from a regional initiative to a
            nationwide movement. Today, we proudly encompass 6,500+ members,
            80+ chapters, and collaborations with over 100 institutions, as well
            as 12 partnering Teacher Associations abroad. Our prop roots
            symbolise our outreach, strengthening and expanding a canopy that nurtures the
            English language teaching community across India.
          </p>
          <h3 className="about_heading alata-light title-font mb-1">Indigenous Approaches</h3>
          <p className="about_txt">
            At ELTAI, we are driven by a commitment to identifying and advancing
            homegrown approaches to English Language and Literature Teaching,
            which we refer to as <b>Indian ELLT</b>. We host a range of enriching
            programmes, including international annual conferences, seminars,
            workshops, webinars, and faculty development programmes (FDPs).
            Moreover, our intellectual contributions extend to publishing four
            peer-reviewed journals, providing a platform for educators to engage
            with cutting-edge research and innovative teaching strategies.
          </p>
          <p className="about_txt">Join us as we celebrate over five decades of excellence in language education, fostering a collaborative spirit that empowers
            educators to create classrooms where languages come alive and learners unlock their full potential. Together, let us continue
            to shape the future of education in India and beyond.</p>
          {
            (currentScope === null || currentScope === undefined || currentScope === '') && (
              <div className="mb-5">
                <Button className='float-end dynamicButton content-font' onClick={joinMember}>Join Us</Button>
              </div>
            )
          }


        </div>

      </section>
    </>


  );
}

export default AboutSection;
